export default "__VITE_ASSET__144e180c__"